import React, { memo, useCallback } from 'react'

import { Check, Icon, Toggle } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import useNotificationPreferences from 'Pods/ThreeDStudio/Shared/NotificationPreferences/useNotificationPreferences'

function NotificationsTab() {
  const t = useTranslation()
  const {
    preferences,
    isBrowserPushSupported,
    setEmailWhenReady,
    setBrowserNotifications,
  } = useNotificationPreferences()

  const handleEmailChange = useCallback((event, checked) => {
    setEmailWhenReady(checked)
  }, [setEmailWhenReady])

  const handleBrowserChange = useCallback((event, checked) => {
    setBrowserNotifications(checked)
  }, [setBrowserNotifications])

  return (
    <section className="settings-modal__tab" aria-label={t('settingsModal.notificationsTitle')}>
      <h3 className="settings-modal__section-title cgt-heading-100">
        {t('settingsModal.notificationsTitle')}
      </h3>

      <div className="settings-modal__indicator">
        <span className="settings-modal__indicator-icon" aria-hidden="true">
          <Icon svgComponent={Check} color="primary" size={iconSizeMedium} notSpaced />
        </span>
        <p className="settings-modal__indicator-text cgt-body-md">
          {t('notificationsPopover.indicator.lead')}
          {' '}
          <span className="cgt-body-md-semibold">{t('notificationsPopover.indicator.highlight')}</span>
          {' '}
          {t('notificationsPopover.indicator.rest')}
        </p>
      </div>

      <hr className="settings-modal__divider" />

      <div className="settings-modal__toggle-row">
        <label
          htmlFor="settings-modal-email-toggle"
          className="settings-modal__toggle-label cgt-body-md-semibold"
        >
          {t('notificationsPopover.emailToggle')}
        </label>
        <Toggle
          id="settings-modal-email-toggle"
          isChecked={preferences.emailWhenReady}
          onChange={handleEmailChange}
        />
      </div>

      <hr className="settings-modal__divider" />

      {isBrowserPushSupported && (
        <>
          <div className="settings-modal__toggle-row">
            <label
              htmlFor="settings-modal-browser-toggle"
              className="settings-modal__toggle-label cgt-body-md-semibold"
            >
              {t('notificationsPopover.browserToggle')}
            </label>
            <Toggle
              id="settings-modal-browser-toggle"
              isChecked={preferences.browserNotifications}
              onChange={handleBrowserChange}
            />
          </div>

          <hr className="settings-modal__divider" />
        </>
      )}
    </section>
  )
}

export default memo(NotificationsTab)
